import ViewSwitcher from "./ViewSwitcher";

export default ViewSwitcher;
